/* eslint-disable no-lone-blocks */
/**
 * @file 合作伙伴
 * @author wanzhongyun
 */
import { useEffect, useRef, useState } from 'react';
import { RootObject, Content2 } from '../../type';
import classNames from 'classnames';
import './style.less';


const Partner = (props: RootObject["partners"]) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (contentRef.current) {

      contentRef.current.style.left = `-${1200 * currentIndex}px`;
    }
  }, [currentIndex]);

  const arrCutting = (array: any[]) => {
    let resultArray: any[] = [];
    if (array.length > 10) {
      let spliceArray: any[] = array.slice(10);
      resultArray.push(array)
      if (spliceArray.length > 10) {
        arrCutting(spliceArray);
      } else {
        resultArray.push(spliceArray);
      };
    } else {
      resultArray.push(array);
    };
    return resultArray;
  };
  let result = arrCutting(props.content);


  return (
    <div className="co-creation-partners">
      <div className="co-creation-partners-title">
        {
          props.title ?? ""
        }
      </div>
      <div className="co-creation-partners-image-wrapper">


        {/* table */}
        <div className="co-creation-partners_content">

          {/* 内容 */}

          <div className="co-creation-partners-content-wrapper">
            <div className="co-creation-partners-content-box" ref={contentRef}>
              {/* 内容模块 */}
              {
                result.map((v: any, i: number) => {
                  return (
                    <div className="co-creation-partners-image-page" key={i}>
                      {
                        v.map((value: Content2, index: number) => {
                          if (index <= 9) {
                            return (<div className='img' style={{ background: `url(${value.img})` }} key={index} />)

                          }else {
                            return null;
                          };
                        })
                      }
                    </div>
                  )
                })
              }
            </div>
          </div>


          {/* table点 */}
          {
            result.length > 1 ?
              <div className="co-creation-partners-tab">
                {result.map((item: any, index: number) => (
                  <div
                    className={classNames('co-creation-partners-tab-item', {})}
                    key={index}
                    // onClick={() => {
                    //   setCurrentIndex(index);
                    // }}
                    onMouseEnter={() => { setCurrentIndex(index); }}
                  >
                    <div
                      className={classNames('co-creation-partners-tab-item-title', {
                        'current-tab-item': index === currentIndex
                      })}
                    >
                    </div>
                  </div>
                ))}
              </div>
              :
              null
          }

        </div>

      </div>
    </div>
  )
}

export default Partner;